import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import SortSelector from '~/components/ui/SortSelector.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryPageHeader',
  props: {
    totalItems: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: function _default() {}
    },
    sorting: {
      type: Object,
      default: function _default() {}
    }
  },
  emits: ['change-sort'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      locale = _useNuxt2App.i18n.locale;
    var route = useRoute();
    var sortOptions = computed(function () {
      var _props$sorting, _props$sorting$option;
      return (_props$sorting = props.sorting) === null || _props$sorting === void 0 ? void 0 : (_props$sorting$option = _props$sorting.options) === null || _props$sorting$option === void 0 ? void 0 : _props$sorting$option.filter(function (option) {
        return option.id.includes('-lang') ? option.id.includes("-lang_".concat(locale)) : true;
      });
    });
    function changeSorting(sort) {
      var oldQuery = _objectSpread({}, route.query);
      var queryUpdate = _objectSpread(_objectSpread({}, oldQuery), {}, {
        sort: sort
      });

      // We are losing reactivity purposefully here
      // to avoid unnecessary rerender of the whole page
      var fullRoute = window.location.origin + route.path;
      var urlParams = new URLSearchParams(queryUpdate).toString();
      history.replaceState({}, null, "".concat(fullRoute, "?").concat(urlParams));
      emit('change-sort', sort);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      locale: locale,
      route: route,
      sortOptions: sortOptions,
      changeSorting: changeSorting,
      SortSelector: SortSelector
    };
  }
});